export * as metamaskInterfaces from './metamaskInterfaces';
export { metamaskChainsParams } from './metamaskChainsParams';

export type { MetaMaskChainParams, ValidChainId } from './metamaskChainsParams';
